var _g, _g2, _tspan, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5250",
    d: "M0 0h200v200H0V0z",
    fill: "#ecf0f1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5203",
    d: "M166.5 181.1c-10.9-6.6-27.6-8.4-35-12.1-4.9-2.5-9.1-4.7-8.9-17.8s1.9-42.4 1.9-42.4H75.4s1.6 29.4 1.9 42.4-4.2 15.6-8.9 17.8c-7.4 3.5-24.1 5.4-35 12.1-10.8 6.6-10 18.9-10 18.9v19.7h153.3V200c-.1 0 .7-12.3-10.2-18.9z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5199",
    d: "M124.5 108.9H75.4c.1 1.8 1.6 29.7 1.9 42.3 0 1.8 0 3.4-.1 4.9 6.7 7.3 14.6 11.9 22.8 11.9 8.2 0 16.1-4.6 22.8-11.9-.1-1.4-.2-3.1-.2-4.9.2-12.7 1.8-40.5 1.9-42.3z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5204",
    d: "M78.7 156.8c.5 4.8 1.7 9.4 3.1 13.9.8 2.3 1.6 4.6 2.6 6.9.8 2 1.7 4.2 3.1 5.9.3.4 1 0 .9-.5-.5-2.2-1.6-4.3-2.4-6.4-.9-2.2-1.7-4.4-2.5-6.6-1.5-4.4-2.8-8.9-4.1-13.3-.2-.4-.8-.3-.7.1zm41.3-1c-1.3 8.2-3.9 16.1-5.4 24.2-.1.4.4.5.6.2 3.1-7.7 4.1-16.1 5.1-24.3-.1-.2-.3-.2-.3-.1zm-25.8 11.9c-.9 3.6 1.9 8.6 6.2 7.6.5-.1.4-.8 0-1-1.4-.5-2.9-.9-3.9-2.1-1.1-1.2-1.5-2.9-1.4-4.5 0-.4-.8-.5-.9 0z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5205",
    d: "M177.3 219.7c-.1-6.6-.3-13.1-.3-19.7l-.3-.3c.1 0 .1 0 .2.1s.1.2.1.1v-1.4c0-.5-.1-.9-.1-1.4-.1-.9-.3-1.9-.5-2.8-.5-1.8-1.1-3.6-2-5.3-1.7-3.4-4.4-6.2-7.7-8.1-3.6-2.2-7.6-3.8-11.6-5.1-4-1.3-8.1-2.4-12.1-3.5-4-1.2-8.1-2.2-11.8-4.2-1.9-1-3.6-2.1-4.8-3.6-1.2-1.6-1.9-3.5-2.3-5.5-.8-4-.4-8.2-.3-12.4l.7-12.6 1.5-25.2.1-1.4h-1.4c-8.2 0-16.4 0-24.6.1l-24.6.3h-.9l.1.9c.8 11.9 1.6 23.8 2.1 35.7.1 3 .3 6 .2 8.9-.1 2.9-.4 5.9-1.6 8.6-.6 1.3-1.4 2.5-2.4 3.5s-2.3 1.8-3.6 2.4c-2.6 1.3-5.4 2.2-8.3 3-5.8 1.5-11.6 2.8-17.3 4.7-2.8.9-5.7 2-8.4 3.4-1.3.7-2.7 1.4-4 2.4-1.3.9-2.4 1.9-3.5 3.1-2.1 2.3-3.6 5.2-4.5 8.1-.5 1.5-.8 3-1 4.6-.1.8-.1 1.6-.1 2.4v2.3l-.2 17.9v1.3h1.4l38.3.2c12.8.1 25.5.1 38.3 0 12.8-.1 25.6-.1 38.3-.3 12.8-.2 25.6-.5 38.3-.7h.6v-.5zm-77.2-1.6H61.8l-37 .2-.1-16.6v-2.2c0-.7 0-1.4.1-2.1.1-1.4.4-2.8.8-4.2.8-2.7 2.1-5.3 3.9-7.5.9-1.1 2-2.1 3.1-2.9 1.1-.9 2.4-1.6 3.7-2.3 2.6-1.4 5.3-2.5 8.1-3.5 5.6-2 11.4-3.4 17.1-5.1 2.9-.8 5.8-1.7 8.5-3.1 1.3-.7 2.7-1.5 3.8-2.6 1.1-1.1 2-2.4 2.6-3.9 1.2-2.9 1.5-5.9 1.6-8.9 0-3-.1-6-.2-9l-1.3-34.8 23.5.4c7.7.1 15.4.1 23.1.1-.4 7.9-.8 15.9-1.1 23.8-.2 4.2-.2 8.4-.3 12.6 0 4.2-.2 8.5.8 12.8.5 2.1 1.3 4.2 2.8 6 1.4 1.7 3.4 2.9 5.3 3.8 3.9 1.9 8 2.8 12.1 3.8s8.2 2 12.2 3.3c4 1.3 7.9 2.8 11.5 5 3.2 1.9 5.8 4.7 7.5 8 .9 1.6 1.5 3.4 1.9 5.2.2.9.4 1.8.4 2.7.1.5.1.9.1 1.4V200l-.3 19c-12.6-.2-25.1-.5-37.7-.7-12.7-.1-25.5-.1-38.2-.2z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5093",
    d: "M179.3 220.1c0-17.5-1.6-26.7-1.6-26.7-3-14-21.9-18.2-30.7-20.1-15.2-3-20.1-7.2-20.1-7.2s-6.4 16-27.5 16-26.8-16.6-26.8-16.6-5.3 4.1-21.2 7.1c-8.7 1.9-26.3 6.9-29.3 20.9 0 0-1.6 9.2-1.6 26.7h158.8z",
    fill: "#386e77",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5094",
    d: "M179.6 209.2c-.1-3.6-.2-7.3-.5-10.9l-.3-2.7c-.1-.9-.2-1.8-.4-2.8-.4-1.9-1.1-3.6-2.1-5.3-1.9-3.3-4.9-5.9-8-7.9-3.2-2-6.6-3.5-10.1-4.7-3.5-1.2-7.1-2.1-10.6-2.9-3.5-.7-7-1.6-10.4-2.7-1.7-.6-3.3-1.2-4.9-1.9-.8-.4-1.6-.7-2.4-1.1-.4-.2-.8-.4-1.1-.6-.3-.2-.7-.5-1-.6-.1-.1-.2-.1-.3-.2-.7-.3-1.5 0-1.8.7-.5 1.1-1.2 2.3-1.9 3.4-.8 1.1-1.6 2.1-2.5 3.1-1.8 1.9-3.9 3.6-6.2 5-4.6 2.7-10.1 4-15.5 4.1-5.4.1-11-1-15.7-3.8-4.7-2.8-8.6-7.1-10.7-12.1 0 0 0-.1-.1-.1-.2-.2-.5-.3-.7-.1-1.4 1-3.1 1.8-4.7 2.4-1.7.7-3.4 1.3-5.1 1.8-3.5 1.1-7 1.9-10.5 2.6-7.1 1.5-14.3 3.5-20.6 7.6-3.1 2-6 4.6-7.9 7.9-1 1.6-1.7 3.4-2.2 5.3-.1.2-.1.5-.2.7l-.1.7-.2 1.4-.3 2.7c-.8 7.3-1.1 14.6-1.2 21.9 0 .7.6 1.4 1.3 1.4l40 .2c13.3 0 26.7-.1 39.9-.2l39.8-.3 36.9-.6 2.2-.4c.1-3.8.1-7.3.1-11zm-20.5 10.4-20-.3-39.7-.5c-13.2-.1-26.3-.2-39.4-.2l-38 .2c0-6.8.1-13.6.7-20.3l.3-2.7.1-1.3.1-.7c0-.2.1-.4.1-.6.4-1.6 1-3.3 1.8-4.8 1.7-3 4.2-5.6 7.1-7.6 2.9-2 6.2-3.6 9.5-4.9s6.8-2.3 10.4-3c3.6-.7 7.1-1.6 10.6-2.7 1.7-.6 3.5-1.2 5.2-1.9 1.5-.6 3-1.3 4.5-2.2 1.1 2.5 2.5 4.7 4.2 6.8 1.8 2.2 4 4.1 6.5 5.6 4.9 3.1 10.7 4.4 16.4 4.5 5.7.1 11.6-1 16.7-3.8 2.6-1.4 4.9-3.2 6.9-5.3 1.7-1.8 3.1-3.6 4.3-5.8.4.2.8.5 1.2.7.8.4 1.7.9 2.5 1.2 1.7.8 3.4 1.4 5.2 2 3.5 1.1 7.1 2 10.7 2.7 7 1.4 14 3.3 20.1 6.9 3 1.8 5.7 4.1 7.6 7 .9 1.4 1.6 3.1 2.1 4.7.2.8.3 1.7.4 2.6l.3 2.7c.4 3.6.8 7.2 1 10.8.2 3.6.4 7.3.6 10.8l-20-.6zM38.3 188.5c1.4 3.2 2.4 6.5 3.2 9.9.4 1.7.8 3.4 1.1 5.1.3 1.7.6 3.4.9 5.2.5 3.2 1 6.4 1.4 9.6h.2c.2-3.2.2-6.5 0-9.8-.3-3.5-.8-7.1-1.6-10.6-.4-1.7-.9-3.5-1.5-5.2-.6-1.7-1.3-3.4-2.2-4.9-.8-1.6-1.8-3.1-3-4.5-1-1.1-2-2.2-3.2-3.1-.1 0-.1.1-.2.1 1 1.1 1.8 2.3 2.6 3.5.8 1.5 1.6 3.1 2.3 4.7zm118.3 20.1c.3-1.7.6-3.5.9-5.2.3-1.7.6-3.4 1.1-5.1.8-3.4 1.8-6.7 3.2-9.9.7-1.6 1.5-3.1 2.4-4.6.7-1.1 1.5-2.3 2.4-3.3-.1-.1-.2-.1-.2-.2-1.1.8-2.1 1.8-3 2.9-1.1 1.4-2.1 2.9-3 4.5-.9 1.6-1.6 3.2-2.2 4.9-.6 1.7-1.1 3.4-1.5 5.2-.8 3.5-1.3 7-1.6 10.6-.2 3.5-.3 7.1 0 10.6.5-3.5 1-6.9 1.5-10.4zM116 183.8c-5.2 2.9-11.3 3.9-17.3 3.5-1.5-.1-3-.2-4.5-.4s-2.9-.5-4.4-.9c-1.4-.4-2.8-.9-4.2-1.5-1.3-.6-2.7-1.3-3.9-2.1-2.5-1.6-4.8-3.6-6.7-5.8-2-2.2-3.7-4.7-5-7.3 2 5.6 5.8 10.7 10.9 14.3 2.5 1.8 5.4 3.2 8.4 4.1 1.5.4 3.1.8 4.6 1 1.6.2 3.1.4 4.7.4 3.1.1 6.3 0 9.4-.7 3.1-.7 6.1-1.8 8.8-3.4 2.7-1.6 5.1-3.6 7.2-5.8 2.1-2.2 4-4.6 5.6-7.1-4 4.5-8.3 8.8-13.6 11.7z",
    fill: "#184f58",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5103",
    d: "M62 92.9c-.2-.3-3.3-4.3-5.9-6.7-2.6-2.4-3.4-2.4-4.6-.9-1.3 1.5-2.9 9.1-2.5 12.4.4 3.4 3.6 8.7 5.2 11.7 1.7 3 3.3 6.7 5.1 6.3 1.9-.4 4.4-4.6 5.7-7.7 1.3-3.1.5-10.8-3-15.1z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5104",
    d: "M65.8 102c.1.9.2 1.7.2 2.6s0 1.7-.2 2.6c-.1.4-.2.9-.3 1.3-.1.4-.3.7-.4 1.1-.3.7-.6 1.4-1 2.1-.7 1.3-1.5 2.6-2.6 3.6-.5.5-1.1 1-1.8 1.3-.4.1-.9.1-1.3 0-.4-.2-.8-.5-1.1-.8-1.2-1.3-1.9-2.8-2.7-4.3-.7-1.5-1.5-2.9-2.2-4.3-.7-1.5-1.5-2.9-2.1-4.4-.3-.8-.7-1.5-.9-2.3-.3-.8-.5-1.6-.6-2.5-.2-1.7 0-3.4.1-5 .2-1.6.5-3.2.8-4.8.2-.8.4-1.6.8-2.3l.3-.6c.1-.2.3-.4.4-.5.2-.3.5-.6.9-.8.3-.2.8-.3 1.2-.3.4.1.8.3 1.1.5.7.4 1.2 1 1.8 1.5 2.2 2.2 4 4.8 5.9 7.2 1.9 2.4 3.2 5.7 3.7 9.1zM55.7 86.4c-1.1-.9-2.4-1.9-3.1-1.2-.2.1-.4.4-.6.6l-.3.3c-.1.1-.1.3-.2.4-.3.6-.5 1.3-.8 2-.5 1.4-.9 2.9-1.1 4.5-.3 1.5-.5 3.1-.4 4.7.1.8.3 1.6.6 2.3.3.8.6 1.5.9 2.2.7 1.5 1.5 2.8 2.3 4.2.8 1.4 1.7 2.7 2.5 4.1.4.7.8 1.4 1.2 2s.8 1.3 1.3 1.7c.5.4.9.6 1.3.4.5-.2.9-.6 1.4-1.1.9-1 1.6-2.1 2.3-3.4.4-.6.7-1.3 1-1.9.2-.3.3-.7.4-1l.2-.5c0-.2.1-.3.1-.5.3-1.4.4-3 .3-4.6s-.4-3.2-.9-4.8c-.5-1.6-1.2-3-2.2-4.2-1.9-2.1-4-4.3-6.2-6.2z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5105",
    d: "M51.2 99.4c-.3-2.3-.5-7.8.8-9.6 2.2-2.9 6 6.4 6.9 9.3 0 .1.1.2.1.3.2.3-.1.7-.4.6-.4-.2-.9-.6-1.3-.8-1.1-.5-1.6.5-1.3 1.8.4 1.8 1.4 2.9 2.2 4.3.1.2 0 .4-.2.3-1.6-.9-3.5-4.5-3.1-6.6.3-2 1.9-1.8 3.1-.8-.7-1.7-1.5-3.3-2.5-4.8-.6-.9-1.2-2-2.2-2.2-1.2-.2-1 .3-1.2 1.8-.8 4.8-.3 10.4 2.5 14.5.1.1 0 .2-.1.1-1.8-2.3-3-4.9-3.3-8.2z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5106",
    d: "M138 92.9c.2-.3 3.3-4.3 5.9-6.7 2.6-2.4 3.4-2.4 4.6-.9 1.3 1.5 2.9 9.1 2.5 12.4s-3.6 8.7-5.2 11.7c-1.7 3-3.3 6.7-5.1 6.3-1.9-.4-4.4-4.6-5.7-7.7s-.5-10.8 3-15.1z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5107",
    d: "M138 92.9c1.9-2.4 3.8-5 5.9-7.2.5-.5 1.1-1.1 1.8-1.5.3-.2.7-.4 1.1-.5.4-.1.9.1 1.2.3.3.2.6.5.9.8.1.1.2.3.4.5l.3.6c.3.7.6 1.5.8 2.3.4 1.6.7 3.2.8 4.8.2 1.6.3 3.3.1 5-.1.9-.4 1.7-.6 2.5-.3.8-.6 1.6-.9 2.3-.7 1.5-1.4 3-2.1 4.4-.8 1.5-1.5 2.9-2.2 4.3-.8 1.4-1.4 3-2.7 4.3-.3.3-.7.6-1.1.8-.4.2-.9.2-1.3 0-.8-.3-1.3-.8-1.8-1.3-1-1.1-1.8-2.3-2.6-3.6-.4-.7-.7-1.4-1-2.1-.2-.4-.3-.7-.4-1.1-.1-.4-.3-.8-.3-1.3-.1-.9-.2-1.7-.2-2.6s.1-1.7.2-2.6c.4-3.4 1.7-6.7 3.7-9.1zm.1.1c-1 1.2-1.7 2.7-2.2 4.2-.5 1.6-.8 3.2-.9 4.8-.1 1.6 0 3.2.3 4.6 0 .2.1.3.1.5l.2.5c.1.3.3.7.4 1 .3.7.6 1.3 1 1.9.7 1.2 1.5 2.4 2.3 3.4.4.5.9.9 1.4 1.1.4.2.8 0 1.3-.4s.9-1 1.3-1.7c.4-.6.8-1.3 1.2-2 .8-1.4 1.7-2.8 2.5-4.1.8-1.4 1.6-2.8 2.3-4.2.4-.7.7-1.5.9-2.2.3-.8.5-1.6.6-2.3.1-1.6-.1-3.2-.4-4.7-.3-1.5-.7-3-1.1-4.5-.2-.7-.5-1.4-.8-2-.1-.1-.1-.3-.2-.4-.1-.1-.1-.2-.3-.3-.2-.2-.4-.5-.6-.6-.7-.6-2 .4-3.1 1.2-2.2 1.5-4.3 3.7-6.2 6.2z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5108",
    d: "M148.8 99.4c.3-2.3.5-7.8-.8-9.6-2.2-2.9-6 6.4-6.9 9.3 0 .1-.1.2-.1.3-.2.3.1.7.4.6.4-.2.9-.6 1.3-.8 1.1-.5 1.6.5 1.3 1.8-.4 1.8-1.4 2.9-2.2 4.3-.1.2 0 .4.2.3 1.6-.9 3.5-4.5 3.1-6.6-.3-2-1.9-1.8-3.1-.8.7-1.7 1.5-3.3 2.5-4.8.6-.9 1.2-2 2.2-2.2 1.2-.2 1 .3 1.2 1.8.8 4.8.3 10.4-2.5 14.5-.1.1 0 .2.1.1 1.8-2.3 3-4.9 3.3-8.2z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5185",
    d: "M143.6 82c-1.2-30.1-20.8-46.6-43.6-46.6S57.6 51.9 56.4 82c0 .9-.1 1.9-.1 2.8 0 31.9 20.2 68.9 43.7 68.9s43.7-37 43.7-68.9c0-1 0-1.9-.1-2.8z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5186",
    d: "M100 153.7c23.5 0 43.7-37 43.7-68.9 0-1 0-1.9-.1-2.8-1.2-30.1-20.8-46.6-43.6-46.6S57.6 51.9 56.4 82c0 .9-.1 1.9-.1 2.8 0 31.9 20.2 68.9 43.7 68.9zm-33.9-33.2c-1.4-3-2.7-6.1-3.8-9.2s-2-6.3-2.8-9.6c-3.1-12.9-3.4-27 1.8-39.4l1.1-2.2c.4-.7.7-1.5 1.1-2.2l1.3-2.1.7-1.1c.2-.3.5-.7.8-1 1-1.3 2-2.6 3.2-3.8.6-.6 1.1-1.2 1.7-1.8l1.9-1.6c5.1-4.2 11.2-6.8 17.5-8.1 1.6-.4 3.2-.5 4.8-.7.8-.1 1.6-.1 2.4-.1l2.4-.1c3.2.1 6.4.4 9.6 1.1.8.2 1.6.3 2.3.5l2.3.7 1.2.4 1.1.5 2.2.9c.7.3 1.4.8 2.1 1.1.7.4 1.5.7 2.1 1.2 1.3.9 2.8 1.7 4 2.8 5.1 4.1 9.3 9.4 12 15.5s4.1 12.8 4.4 19.6c.3 6.7-.5 13.5-2.2 20-1.6 6.5-4 12.8-7 18.8s-6.6 11.5-10.7 16.5c-2.1 2.5-4.4 4.8-6.8 6.8-2.5 2-5.1 3.7-8 4.9-2.8 1.2-5.8 1.9-8.8 1.9s-6-.7-8.8-1.9c-5.7-2.4-10.6-6.8-14.7-11.9-4.2-4.7-7.6-10.4-10.4-16.4z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5274",
    d: "M86.62 127.55s2.05 2.59 5.62 4.12 13.46 4.37 22.92-4c0 0-1.83-1.01-4.25-2.59s-3.79-2.39-5.87-2.71-3.23.58-4.6.64c-1.37.05-2.88-.8-4.51-.66-3.58.3-9.36 4.5-9.36 4.5l.05.7z",
    fill: "#da7c87",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5275",
    d: "M85.9 127.36c1.93 1.35 3.95.8 6.06.2 1.1-.31 1.84-.44 3.03-.4 1.4.05 1.65.32 2.77.82.84.37 1.64.61 2.55.48 1.07-.15 1.89-.82 2.89-1.19 2.34-.87 4.17.21 6.35.86 2.06.61 4.33 1.01 6.18-.31.5-.36.08-1.04-.47-.81-2.86 1.23-5.62-.26-8.45-.67-2.23-.32-3.49.46-5.64.81-2.45.4-4.48-1.02-6.92-1.03-2.61-.02-5.17 1.6-7.62 0-.78-.53-1.48.71-.73 1.24z",
    fill: "#cb5f6c",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6230",
    d: "M88.2 99.8s.1-4-2.3-6.6c-2.4-2.6-6.4-5.6-14.3-2.8 0 0 1.3 3.7 2.8 5.3 1.5 1.5 4.7 3.8 7.6 4.2 3 .3 6.2-.1 6.2-.1z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5220",
    d: "M80.1 88.4c2.8 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2-5.2-2.3-5.2-5.2 2.3-5.2 5.2-5.2z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5221",
    d: "M80.1 90.8c1.5 0 2.8 1.2 2.8 2.8s-1.2 2.8-2.8 2.8-2.8-1.2-2.8-2.8 1.2-2.8 2.8-2.8z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5222",
    d: "m79.4 91.3-.6-.6c-.2-.2-.4-.3-.7-.3-.2 0-.5.1-.7.3-.2.2-.3.4-.3.7s.1.5.3.7l.6.6c.2.2.4.3.7.3.2 0 .5-.1.7-.3.3-.5.4-1.1 0-1.4zm2.5 4.7c.9 0 .9-1.4 0-1.4s-.8 1.4 0 1.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6238",
    d: "M69.4 94.6c0 6.4 4.7 11.5 10.6 11.5s10.6-5.2 10.6-11.5S85.9 83.1 80 83.1s-10.6 5.1-10.6 11.5zm2.2-4.2c7.9-2.9 12 .2 14.3 2.8 2.4 2.6 2.3 6.6 2.3 6.6s-3.2.5-6.2.1c-2.9-.4-6.1-2.7-7.6-4.2s-2.8-5.3-2.8-5.3z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6239",
    d: "M71.2 90.6c2.4 7.1 9.7 11.3 17.1 9.5.2-.1.2-.3.1-.4.8-3.5-1.7-7.2-4.5-9.1-3.3-2.1-9-2.9-12.4-.7-.1.1-.1.2-.1.3-.2.1-.3.2-.2.4zm.7-.2c1.6-.2 3.2-.8 4.9-.8 2.1 0 4.2.4 6 1.4 3.4 1.9 4.6 5 5.2 8.5-3.6 0-7 .1-10.2-1.7-2.8-1.6-4.8-4.3-5.9-7.4z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6231",
    d: "M111.8 99.8s-.1-4 2.3-6.6c2.4-2.6 6.4-5.6 14.3-2.8 0 0-1.3 3.7-2.8 5.3-1.5 1.5-4.7 3.8-7.6 4.2-3 .3-6.2-.1-6.2-.1z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5223",
    d: "M119.9 88.4c2.8 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2-5.2-2.3-5.2-5.2 2.4-5.2 5.2-5.2z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5224",
    d: "M119.9 90.8c1.5 0 2.8 1.2 2.8 2.8s-1.2 2.8-2.8 2.8-2.8-1.2-2.8-2.8 1.3-2.8 2.8-2.8z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5225",
    d: "m119.3 91.3-.6-.6c-.2-.2-.4-.3-.7-.3-.2 0-.5.1-.7.3-.2.2-.3.4-.3.7s.1.5.3.7l.6.6c.2.2.4.3.7.3.2 0 .5-.1.7-.3.3-.5.4-1.1 0-1.4zm2.5 4.7c.9 0 .9-1.4 0-1.4s-.9 1.4 0 1.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6240",
    d: "M120 83.1c-5.9 0-10.6 5.2-10.6 11.5s4.7 11.5 10.6 11.5 10.6-5.2 10.6-11.5-4.8-11.5-10.6-11.5zm5.6 12.6c-1.5 1.5-4.7 3.8-7.6 4.2-2.9.4-6.2-.1-6.2-.1s-.1-4 2.3-6.6c2.4-2.6 6.4-5.6 14.3-2.8 0 0-1.3 3.7-2.8 5.3z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6243",
    d: "M128.7 90.2c0-.1 0-.2-.1-.3-3.4-2.2-9.2-1.4-12.4.7-2.8 1.8-5.4 5.6-4.5 9.1-.1.1-.1.4.1.4 7.4 1.7 14.7-2.4 17.1-9.5 0-.2-.1-.3-.2-.4zm-6.5 7.7c-3.2 1.9-6.6 1.8-10.2 1.7.6-3.6 1.8-6.7 5.2-8.5 1.8-1 3.9-1.5 6-1.4 1.7 0 3.2.6 4.9.8-1.1 3-3.1 5.7-5.9 7.4z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,1.7453292519943295e-9,-1.7453292519943295e-9,1,1.4176201545978984e-7,-1.3606350535155798e-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5069",
    d: "M67 82.5c.1-.3.3-.6.5-.8.1-.2.3-.5.5-.7.2-.2.4-.4.7-.6.5-.9 1.7-1.6 2.5-2.1.9-.5 1.8-.9 2.9-.9 1-.2 2.1-.2 2.9.2.4 0 .7.1 1 .3 1.1-.1 2.3.2 3.3.4 1.4.3 2.8.6 4.1 1.2 1.4 0 2.8.1 4.1.5h.2c.1 0 .2.1.2.1h.1c.1 0 .2.1.3.2.1.1 0 .3 0 .4v.1c0 .2 0 .4-.1.6 0 .6-.1 1.1-.5 1.6 0 .1 0 .2-.1.3-.1.5-.2 1.1-.7 1.4-.2.2-.5.3-.8.3-.1 0-.2 0-.3-.1h-.6c-.6.2-1.4 0-1.9-.1-.6-.1-1.2-.3-1.7-.6-1.8-.3-3.5-.8-5.3-1.2-1.6-.4-4-.4-5.4-1.3-.7.1-1.3.2-2 .2-.3 0-.7.1-1.1 0-.2 0-.5 0-.7-.2 0 0-.1 0-.1-.1h-.1l-.4.4c-.3.3-.7.7-1.2.8-.1.2-.3 0-.3-.3z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5070",
    d: "M87.7 83c-.1-.6-.2-1.2-.4-1.7 0-.2.2-.3.3-.1.7 1 .9 2.8.2 3.9-.1.2-.3.1-.3-.1.1-.8.2-1.4.2-2zm-3.4-3.2c1.3.8 2.1 2.6 2.1 4 0 .2-.3.3-.3.1-.2-.7-.4-1.3-.7-1.9-.3-.7-.9-1.2-1.3-1.9-.3-.2 0-.4.2-.3zm-3.3-.7c2.2.8 3.8 3.2 4.2 5.3 0 .2-.2.2-.3.1-.4-1-.9-2-1.7-2.8-.7-.9-1.6-1.4-2.5-2.2-.2-.1.1-.5.3-.4zm-4.9-.8c2.4.6 4.8 2.6 5.8 4.7.1.2-.3.4-.4.2-.8-1-1.6-1.9-2.6-2.7-.9-.7-2-1.2-3-1.8-.2-.1-.1-.4.2-.4zM67.4 82c1.6-1.8 3.8-4.3 6.5-4 .2 0 .2.3 0 .3-2.6.2-4.3 2.5-6.3 3.9-.2.1-.4-.1-.2-.2z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5071",
    d: "M90.9 80.6c-.1-.3-.5-.3-.6 0-.3 1.1-.3 2.4-1.2 3.3-.6.7-1.5.8-2.4.7.3-1.5.2-3.7-.8-4.9-.2-.2-.5-.1-.4.2 0 .8.4 1.6.5 2.4.1.8.2 1.5.2 2.3-.1 0-.2 0-.3-.1-.3-2-1.3-4.1-2.8-5.5 2.3.5 4.6.9 6.9 1.1.1 0 .2-.2.1-.2-2.6-.9-5.3-1.4-8-2-2.4-.5-5.1-1.4-7.6-1.5-2.1-.1-3.6.9-5 2.2-1.5 1.4-3.1 3.1-4.1 4.9l-.2.2c-.1.1-.2.3-.1.4 0 0 0 .1-.1.1-.2.4.3.7.6.4.1 0 .2 0 .3-.1 1.4-.7 2.5-1.4 4.1-1.6 1.3-.2 2.7-.1 4 .1 2.9.4 5.6 1.3 8.3 2.1 2.1.6 4.9 1.7 6.9.2 1.7-1 1.9-3.1 1.7-4.7zm-13.4 1.3c-.5-.1-1.1-.2-1.7-.3.1-1.1-.3-2.3-.8-3.3.7.6 1.4 1.2 2 1.9.6.6.9 1.4 1.5 2-.4-.1-.7-.2-1-.3zM70 79.5c1.2-1.1 2.5-1.7 4-1.9.2.8.6 1.6.7 2.4l.3 1.5c-.3 0-.7-.1-1-.1-.5-.9-1.3-1.8-2.3-2.1-.2-.1-.3.2-.2.4.4.4.9.8 1.3 1.2.1.2.2.3.4.5-1.9-.1-3.8.1-5.4.8.6-1 1.3-1.9 2.2-2.7zm15.2 4.8c-.2-.1-.4-.1-.6-.2-.4-.1-.9-.3-1.3-.4-.8-1.8-2.1-3.6-3.7-4.8-.2-.1-.4.1-.3.2 1.2 1.4 2.2 2.9 3.3 4.4-1.1-.4-2.2-.7-3.2-1.1-.2-1.1-1.2-2.2-1.9-3-.7-.7-1.5-1.4-2.4-1.9.4 0 .8.1 1.3.1 2 .3 4 .8 6 1.2v.1c.7 1.1 1.5 2.2 2.1 3.3.2.7.4 1.4.7 2.1z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,1.7453292519943295e-9,-1.7453292519943295e-9,1,1.4176202967064455e-7,-2.127084570702209e-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5072",
    d: "M133 82.5c-.1-.3-.3-.6-.5-.8-.1-.2-.3-.5-.5-.7-.2-.2-.4-.4-.7-.6-.5-.9-1.7-1.6-2.5-2.1-.9-.5-1.8-.9-2.9-.9-1-.2-2.1-.2-2.9.2-.4 0-.7.1-1 .3-1.1-.1-2.3.2-3.3.4-1.4.3-2.8.6-4.1 1.2-1.4 0-2.8.1-4.1.5h-.2c-.1 0-.2.1-.2.1h-.1c-.1 0-.2.1-.3.2-.1.1 0 .3 0 .4v.1c0 .2 0 .4.1.6 0 .6.1 1.1.5 1.6 0 .1 0 .2.1.3.1.5.2 1.1.7 1.4.2.2.5.3.8.3.1 0 .2 0 .3-.1h.6c.6.2 1.4 0 1.9-.1.6-.1 1.2-.3 1.7-.6 1.8-.3 3.5-.8 5.3-1.2 1.6-.4 4-.4 5.4-1.3.7.1 1.4.2 2 .2.3 0 .7.1 1.1 0 .2 0 .5 0 .7-.2 0 0 .1 0 .1-.1h.1l.4.4c.3.3.7.7 1.2.8.1.2.3 0 .3-.3z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5073",
    d: "M112.3 83c.1-.6.2-1.2.4-1.7 0-.2-.2-.3-.3-.1-.7 1-.9 2.8-.2 3.9.1.2.3.1.3-.1-.1-.8-.2-1.4-.2-2zm3.4-3.2c-1.3.8-2.1 2.6-2.1 4 0 .2.3.3.3.1.2-.7.4-1.3.7-1.9.3-.7.9-1.2 1.3-1.9.3-.2 0-.4-.2-.3zm3.3-.7c-2.2.8-3.8 3.2-4.2 5.3 0 .2.2.2.3.1.4-1 .9-2 1.7-2.8.7-.9 1.6-1.4 2.5-2.2.2-.1-.1-.5-.3-.4zm4.9-.8c-2.4.6-4.8 2.6-5.8 4.7-.1.2.3.4.4.2.8-1 1.6-1.9 2.6-2.7.9-.7 2-1.2 3-1.8.2-.1.1-.4-.2-.4zm8.7 3.7c-1.6-1.8-3.8-4.3-6.5-4-.2 0-.2.3 0 .3 2.6.2 4.3 2.5 6.3 3.9.2.1.4-.1.2-.2z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5074",
    d: "M110.6 85.3c2 1.5 4.8.4 6.9-.2 2.8-.8 5.5-1.8 8.3-2.1 1.3-.2 2.7-.3 4-.1 1.6.2 2.7.9 4.1 1.6.1.1.2.1.3.1.3.3.8 0 .6-.4 0 0 0-.1-.1-.1 0-.1 0-.3-.1-.4l-.2-.2c-1-1.8-2.6-3.5-4.1-4.9-1.4-1.3-2.9-2.3-5-2.2-2.5.1-5.2 1-7.6 1.5-2.7.6-5.4 1.1-8 2-.2.1-.1.2.1.2 2.3-.2 4.6-.6 6.9-1.1-1.5 1.4-2.5 3.5-2.8 5.5-.1 0-.2 0-.3.1.1-.8.1-1.5.2-2.3.1-.8.5-1.6.5-2.4 0-.2-.3-.3-.4-.2-1 1.2-1.1 3.4-.8 4.9-.9.1-1.7 0-2.4-.7-.8-.9-.9-2.2-1.2-3.4-.1-.3-.5-.3-.6 0 0 1.7.2 3.8 1.7 4.8zm10.9-3.2c.5-.6.9-1.4 1.5-2 .6-.7 1.3-1.3 2-1.9-.5 1-.9 2.3-.8 3.3-.6.1-1.2.2-1.7.3-.3.2-.6.3-1 .3zm10.8 0c-1.6-.7-3.6-.9-5.4-.8.1-.2.2-.3.4-.5.4-.5.9-.8 1.3-1.2.1-.1.1-.4-.2-.4-1 .3-1.8 1.2-2.3 2.1-.3 0-.7.1-1 .1l.3-1.5c.2-.8.5-1.6.7-2.4 1.4.2 2.7.8 4 1.9.8.9 1.5 1.8 2.2 2.7zm-16.7.2c.6-1.2 1.4-2.2 2.1-3.3v-.1c2-.4 4-.9 6-1.2.4-.1.9-.1 1.3-.1-.9.5-1.7 1.2-2.4 1.9-.7.8-1.7 1.9-1.9 3-1.1.3-2.2.7-3.2 1.1 1-1.5 2.1-2.9 3.3-4.4.1-.2-.1-.3-.3-.2-1.6 1.2-2.9 3-3.7 4.8-.4.1-.9.3-1.3.4-.2.1-.4.1-.6.2.2-.8.4-1.5.7-2.1z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5255",
    d: "M105.06 106.65c.56.92 2.64 3.61 3.09 4.9.45 1.29-.13 3.22-1.48 3.61s-3.61-.39-3.93-.19c-.32.19-1.87 2.06-2.58 1.93-.71-.13-2.64-2.13-3.03-2.13-.39 0-2.13.45-2.97.45-.84 0-2.9-.71-2.64-2.51.26-1.81 2.45-5.54 2.9-6.06.45-.52 1.48-2.32 1.74-3.42s.58-7.03.71-8.38c.13-1.35 1.35-2.97 2.58-3.09 1.23-.13 3.35.77 3.55 2.9.19 2.13.58 6.38.77 8.12.19 1.74.58 2.71 1.29 3.87z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5256",
    d: "M97.62 85.76c-.84 3.5-.96 7.24-1.34 10.81-.4 3.83-1.14 7.78-1.09 11.63 0 .31.48.39.55.07.78-3.52.88-7.26 1.24-10.84.39-3.82 1.1-7.79.98-11.63 0-.18-.29-.24-.34-.04z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5257",
    d: "M94.46 106.19c-1.03 1.37-1.9 2.87-2.65 4.41-.49 1-1.09 2.17-.77 3.32.53 1.89 2.93 2.49 4.5 1.58.47-.27.26-.99-.27-1-.92-.01-1.98.28-2.72-.5-.88-.94-.01-2.63.38-3.57.58-1.39 1.28-2.72 1.83-4.12.07-.19-.2-.26-.3-.12z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5258",
    d: "M94.31 113.98c2.84-.21 3.38 3.37 6.07 3.45 2.31.07 2.5-3.41 4.69-3.3.26.01.34-.35.13-.47-2.49-1.47-2.95 2.86-5.24 2.59-1.36-.16-2.32-2.16-3.54-2.73-.83-.39-1.43-.36-2.23.02-.22.09-.11.46.12.44z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5259",
    d: "M104.29 115.6c1.87.42 4.05-.16 4.49-2.24.22-1.04-.13-2.07-.67-2.95-.89-1.44-2.03-2.66-2.87-4.15-.14-.25-.49-.12-.51.14-.11 1.67 1.13 2.83 2.02 4.12.82 1.19 1.53 2.83.15 4-.63.54-1.83.44-2.6.59-.26.04-.25.43-.01.49z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5260",
    d: "M102.45 109.98c-.41-.74-1.47-.85-2.06-.26-.05.05-.24.29-.3.36-.07.09-.2.26-.23.29-.07.1-.12.21-.18.32l-.12.28c0-.01-.01.01-.03.05-.06.06-.12.13-.18.2-.18.19-.36.38-.5.6-.42.67-.08 1.42.48 1.84.87.65 2.13.13 2.74-.61.76-.89.96-2.03.38-3.07z",
    fill: "#f8d5c3",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath8241",
    d: "M108.6 50.3s-1.3 4-3.6 4.8-10.4 1.4-10.7-2.1-2.7-16-15.5-11.6c0 0 1.7-5 9.8-8.4s9.8-3.6 17 .5c7 4.1 5 14.4 3 16.8z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath8242",
    d: "M127.6 59.1s1.6 2.6 3.9 2.6 6.8-4.2 7.6-6.9c.8-2.7 1.8-17.1-10.8-22.7s-3.2 2.8-3.2 2.8 10.8 11.8 2.5 24.2zm4.7.8s-1.4 1.1-.4 2.8c.9 1.8 1.9 4.2 3 9.1s1.1 15.2 1.2 17.1c.1 1.9.1 6.8 1.9 6.9 1.8.1 3.6-.9 4.7-2.8s1.4-10.8 1.4-13.7-.1-16.9-6.6-22.6l-5.2 3.2zm-56.1 9.8s.8 7.4-6.4 9.5c-7.2 2.1-13.6 4.2-10 8.1 3.6 3.8 5.2 4.6 5.2 4.6s-10-4.7-10.5-9.5c-.5-4.7 8.2-9.7 12.9-11.1s8.8-1.6 8.8-1.6zm8.9-31.3c-5.2-.3-8.8 3.7-10.4 7.7s-.9 8.7-.9 8.7c-.1 3.2 4.9 10.1 3.5 7.2-1.4-3.1-.4-4.3.5-6.5.6-1.5 3.7-2 5.6-2 .1 0 .1.1.2.1 3.5 2.2 8.4.7 9.4.3s1.6-1.1 1.7-2.7c.2-5.7-4.4-12.5-9.6-12.8zm38.5 6.9s.6 7.3-3 11.4-15.8.3-14.1-3.5c1.8-3.7 4-9.2 1.9-13.8-2-4.7-6.1-9.6-14.2-8.3 0 0 8.8-2.5 17.9 1.3s10.7 8.7 11.5 12.9z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath8243",
    d: "M67.5 38.9s-11.2 5.9-13.3 14c-2 8.1-3.7 15.5-.9 20.5 0 0-5.9 6.1.9 12.3s9 4.8 9.8 6.8c.7 2 .4 2-.7 2.8 0 0 3 0 3.1-1.7 0 0 .9-1.1-3.9-5.2-4.8-4-7.5-6.4-6.5-8.6s5.4-5.7 9.3-6.4S75 71.3 75.7 69s-.1-3.3-1.8-5.9-6.6-8.5-6.7-11.7c-.2-3.2.3-12.5.3-12.5z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath8244",
    d: "M120.7 56.7s-.5.6 1.4 2.4c1.9 1.8 5.2 1.9 7.9-.5 2.6-2.4 5.6-13.3 2.7-20.2s-10-13.8-22-14.8c0 0 .1-2.6-8.2-4.4S80.4 21 73.6 31c0 0-8.3 1.4-10.2 11.5s6.3 18.3 9.4 22c3.1 3.7-.5 6.6-3.6 7-3.1.5-16.1 2.9-15.2 8.7s10.8 9.9 11.3 12.3c.5 2.4-3.2 2.7-3.8 3.9-.6 1.2-1 4.2 3.8 6.5 0 0-2.5-2.1-2.7-3.9-.2-1.8 1.1-2.7 2.5-3.3 3.1-1.5 2.7-2.9 2-4.3-.7-1.4-5.4-3.9-6.9-5.8s-1.6-4.8.6-7 9.5-4.4 12.9-5.7c9.1-3.6 6.5-5.3 5.8-6.9-1.2-2.6-5-4.6-5.6-8.7s.2-12.2 3.9-16.1 10.5-11.7 25.7-10.8 20.2 10.7 20.7 13.8c.5 3.1-1.2 8.1-3.5 12.5z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath8245",
    d: "M120.7 56.7c-.3.5 9.6-17.2-8.4-23.2S83.8 35 78.2 43c-2.6 3.7-5.4 12.8 1.7 20.6S66.8 73.9 62.4 78.8c-4.4 4.9.7 7.1 4.4 11.4 3.7 4.4-3.4 7.1-3.5 9.1-.2 2 2 3.7 2 3.7s-4-1.8-3.5-4.9c.5-3 7.1-2.9 5.1-5.6-2-2.7-12.5-7.2-8.4-13S78 73.4 79 69.2s-7.9-6.7-6.7-15.7 4.4-14.8 12.3-20 25.3-6.6 35.2 2.4 3.5 16.4.9 20.8zM62 73.3c-2.8.5-6.1 1.3-7.7 4-1.3 2.2-1 5 .7 6.9.1.1.3 0 .2-.2-1.5-2.4-1.7-5.5.4-7.6 1.7-1.7 4.1-2.3 6.3-2.9.3 0 .2-.2.1-.2zM70.2 61c-5.2-5-8.7-11.2-5.6-18.4.1-.3-.2-.4-.4-.2-2.5 3.2-2.5 7.2-1 10.9.6 1.5 1.5 3 2.6 4.3 2.3 2.9 7.7 5.8 7.6 9.9 0 .2.3.2.3 0 .6-2.9-1.5-4.5-3.5-6.5zm24.4-40.7c-11 2.4-23.3 8.7-24.5 21.1 0 .2.3.3.4 0 2.4-12.3 13-17.7 24.1-21.1 0 .1 0 0 0 0zM63.3 64.2c-.9-5-7.5-6.3-6.7-12.1 0-.3-.4-.3-.4-.1-2.5 7.1 12.9 11.5 4.1 18.3-.1.1 0 .2.1.2 2-1.3 3.3-3.7 2.9-6.3zM128.1 33c-6.6-8.6-17.3-9.7-27.3-7.1-.2 0-.1.3.1.3 8.7-1.4 18.3-1.8 24.9 5.3 6.9 7.3 9.3 17.9 2.2 25.9-.2.3.1.6.4.4 7.8-6.5 5.1-17.8-.3-24.8zm11.2 16.8c-.1-.2-.5-.2-.4.1.3 4.8-2.3 8.5-7 9.7-.2.1-.2.5.1.4 4.9-.3 8.6-5.3 7.3-10.2zm1 12.6c-1 2.1-2 4.8-4.8 4.8-.4 0-.4.6 0 .6 2.9.2 4.9-2.6 5.1-5.3.1-.2-.2-.3-.3-.1zm1.1 2c0-.1-.1-.1-.2-.1-.1-.3-.1-.7-.2-1-.1-.2-.3-.1-.3.1 1.4 7.9.1 15-3.1 22.2-.1.2.2.4.3.2 2.1-3.4 3.3-7.1 3.8-11 .2 5.9 0 11.7-.9 17.8 0 .2.3.3.3.1 2.3-9.1 2.7-19.2.3-28.3z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "svga-credit-rect",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "svga-credit-text",
    fontFamily: "Avenir Next, Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    size: "10px",
    anchor: "start",
    weight: 400,
    fill: "#333333",
    x: 33.402061462402344,
    y: 182.71133995056152,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan5063",
    dy: 13,
    x: 33.402061462402344
  }, "Created on AvatarMaker.com")))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs5010"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d28a9dc896c127ae1485c82a6e875c02.svg";
export { ForwardRef as ReactComponent };